import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { AccountCard } from "@components/financialAccount/AccountCard/AccountCard";
import { useFinancialAccounts } from "@hooks/useFinancialAccounts";
import { FieldReviewDetailsRow } from "../fieldReviewDetailsViewConfig";

export const FieldReviewFinancialAccountCell = memo(
    ({
        row,
    }: CellContext<ViewTableFeatures, FieldReviewDetailsRow, unknown>) => {
        const { financialAccountId, resource } = row.original;
        const accounts = useFinancialAccounts();

        if (!financialAccountId) {
            return <ViewTableCell />;
        }

        const account = accounts?.find((a) => a.id === financialAccountId);

        if (!account) {
            const nameValue = resource?.financialAccountName;
            const fallbackName = typeof nameValue === "string" ? nameValue : "";
            return (
                <ViewTableCell>
                    <span>{fallbackName}</span>
                </ViewTableCell>
            );
        }

        return (
            <ViewTableCell>
                <AccountCard account={account} showType={false} iconSize="sm" />
            </ViewTableCell>
        );
    },
);

FieldReviewFinancialAccountCell.displayName = "FieldReviewFinancialAccountCell";
